import React from "react";
import Navbar from "@organism/Navbar/Navbar";
import SEO from "../../components/Seo";
import Calendly from "@organism/Calendly";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import PipeDriveChat from "@utils/pipedriveChat";

const listTokens = {
  es: "AW-10794307547/rRgzCK2mrf8CENufkJso",
  pr: "AW-10794307547/vudSCIPD2v8CENufkJso",
  en: "AW-10794307547/iHzlCNri0_8CENufkJso",
};

const SeeDemoPage = ({ location }) => {
  const { t } = useTranslation();
  const { language } = useI18next();

  return (
    <>
      <SEO
        title={t("HERO.BUTTON")}
        description={t("N5_IMPACT.SUBTITLE")}
        originUrl={location.origin}
        siteUrl={location.href}
        lang={language}
      >
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-10794307547"
          type="text/javascript"
        />
        <meta
          name="linkedin pixel"
          content="https://px.ads.linkedin.com/collect/?pid=1272170&conversionId=6218961&fmt=gif"
        />
        <script>
          {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-10794307547');
          gtag('event', 'conversion', {
            'send_to': '${listTokens[language]}',
          });
          `}
        </script>
      </SEO>
      <Navbar location={location} platform ideasVisible={false} />
      <div
        style={{
          // Mismo gris que el fondo interno del webform de Pipedrive (#f7f7f7),
          // para que página e iframe se vean como un único plano continuo.
          background: "#f7f7f7",
          minHeight: "100vh",
        }}
      >
        <h1 className="sr-only">{t("HERO.BUTTON")}</h1>
        <Calendly />
        <PipeDriveChat />
      </div>
    </>
  );
};

export default SeeDemoPage;
